/**
 * SimulateurDOS - Wrapper pour le Simulateur DOS-DOMIUM
 * COPPAM – Garanties Solidaires
 * 
 * Ce composant peut basculer entre :
 * - DOSMVPSimulateur : Ancien simulateur (calcul rapide)
 * - DOMIUMSubscriptionSimulator : Nouveau workflow complet (Étape A - Pré-admission)
 * 
 * Fonctionnalités du nouveau workflow :
 * - Saisie complète identité souscripteur
 * - Données opération et techniques
 * - Calcul automatique de la contribution
 * - Génération des Conditions Particulières
 * - Génération de la facture proforma
 * - Checklist des documents requis
 */
import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Calculator, FileSignature, Brain } from 'lucide-react';
import DOSMVPSimulateur from './DOSMVPSimulateur';
import DOMIUMSubscriptionSimulator from './DOMIUMSubscriptionSimulator';
import DOMIUMDocIAAnalysis from './DOMIUMDocIAAnalysis';

export default function SimulateurDOS({ userRole = 'super_admin', defaultMode = 'subscription' }) {
  const [mode, setMode] = useState(defaultMode);
  const [iaPrefill, setIaPrefill] = useState(null);

  const handleApplyToForm = (draft) => {
    // Injecte les données extraites par l'IA dans le formulaire de souscription.
    setIaPrefill({ ...draft, _ts: Date.now() });
    setMode('subscription');
  };

  return (
    <div className="space-y-4">
      <Tabs value={mode} onValueChange={setMode} className="w-full">
        <TabsList className="grid grid-cols-3 w-[600px] max-w-full">
          <TabsTrigger value="subscription" className="flex items-center gap-2">
            <FileSignature className="h-4 w-4" />
            Souscription DOMIUM
          </TabsTrigger>
          <TabsTrigger value="calculator" className="flex items-center gap-2">
            <Calculator className="h-4 w-4" />
            Calculateur rapide
          </TabsTrigger>
          <TabsTrigger value="ia-analyse" className="flex items-center gap-2" data-testid="domium-ia-tab">
            <Brain className="h-4 w-4" />
            Analyse IA
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="subscription" className="mt-4" forceMount>
          <div style={{ display: mode === 'subscription' ? undefined : 'none' }}>
            <DOMIUMSubscriptionSimulator userRole={userRole} iaPrefill={iaPrefill} />
          </div>
        </TabsContent>
        
        <TabsContent value="calculator" className="mt-4">
          <DOSMVPSimulateur userRole={userRole} />
        </TabsContent>

        <TabsContent value="ia-analyse" className="mt-4" forceMount>
          <div style={{ display: mode === 'ia-analyse' ? undefined : 'none' }}>
            <DOMIUMDocIAAnalysis onApplyToForm={handleApplyToForm} />
          </div>
        </TabsContent>
      </Tabs>
    </div>
  );
}

